import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CreateInvoiceRequest {
  companyId: string;
  poId?: string | number;
  receiptId?: number;
  invoiceNumber?: string;
  attachmentIds?: number[];
  supplierId?: number;
  useSinglePeriod?: boolean;
  poSubject?: string;
  accrualDate?: string;
}

export interface CreateInvoiceResponse {
  invoiceId: number;
  poId?: number;
}
const useCreateInvoiceApi = () => {
  const call = useCallback(
    (req?: CreateInvoiceRequest) =>
      new Promise<CreateInvoiceResponse>((resolve, reject) => {
        axiosInstance
          .post<CreateInvoiceResponse>(`/Invoice`, req)
          .then((data) => {
            resolve(data.data);
            return data.data;
          })
          .catch((e) => {
            reject(new Error(e));
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    createInvoice: execute,
    isCreateInvoiceLoading: isLoading,
  };
};

export default useCreateInvoiceApi;
